import axios from 'axios';

export const areaFetch = () => {
    return (dispatch) => {
        
        dispatch({ type: "AREALOADER", response: true });
        axios({
            method: "get",
            headers: {"arixauth" : localStorage.getItem("arixauth")},
            url: `${process.env.REACT_APP_APIURL}/tenant/getareas`,
          })
            .then((response) => {
                dispatch({ type: "GET_AREADATA", response: response.data });
            })
            .catch((error) => {
                
                dispatch({ type: "AREAFAIL", response: false });
              
            })
    }
}

export const featureFetch = () => {
   
    return (dispatch) => {
        
        dispatch({ type: "FEATURELOADER", response: true });
        axios({
            method: "get",
            headers: {"arixauth" : localStorage.getItem("arixauth") , "arixrdx" : 'OK' },
            url: `${process.env.REACT_APP_APIURL}/tenant/getfeature`,
          })
            .then((response) => {
                
                dispatch({ type: "GET_FEATURELOADER", response: response.data });
            })
            .catch((error) => {
                
                dispatch({ type: "FEATUREFAIL", response: false });
              
            })
    }
}